import React from "react";

import Divider from "@busbud/design-system-components/dist/Divider";
import Label from "@busbud/design-system-components/dist/Label";
import Stack from "@busbud/design-system-components/dist/Stack";

import type { SimplifiedTerms } from "@app/modules/terms/flatten-terms";

import { SimplifiedTermsEntry } from "./terms-simplified-entry";

interface Props {
  terms: SimplifiedTerms[];
  title?: string;
  alert?: React.ReactNode;
  withDivider?: boolean;
  classes?: { simplifiedTermsDivider: string };
}

export const SimplifiedTermsSection: React.FC<Props> = ({
  title,
  terms,
  alert,
  withDivider = false,
  classes
}) => {
  return (
    <Stack direction="column" spacing={1}>
      {!!title && (
        <>
          <Label
            size="xs"
            color="text.tertiary.opaque"
            fontWeight="bold"
            data-test-id="title-section"
          >
            {title}
          </Label>
          {!!withDivider && <Divider />}
        </>
      )}
      {alert}
      <Stack direction="column" spacing={1}>
        {terms.map((simplified_term, index) => {
          return (
            <React.Fragment key={index}>
              <SimplifiedTermsEntry terms={simplified_term} />
              {!!withDivider && (
                <Divider className={classes?.simplifiedTermsDivider} />
              )}
            </React.Fragment>
          );
        })}
      </Stack>
    </Stack>
  );
};
